import { useState } from "react";

function useBitcoinAddressValidation() {
  const [bitcoinAddress, setBitcoinAddress] = useState("");
  const [isValid, setIsValid] = useState(false); // Cambiar el valor inicial a false

  const validateBitcoinAddress = (address) => {
    // Si la dirección está vacía, no es válida
    if (!address) {
      return false;
    }
    // Expresión regular para validar direcciones de Bitcoin Testnet
    const testnetRegex = /^[2mn][a-km-zA-HJ-NP-Z1-9]{25,39}$/;
    return testnetRegex.test(address);
  };

  const handleBitcoinAddressChange = (event) => {
    const address = event.target.value;
    setBitcoinAddress(address);
    setIsValid(validateBitcoinAddress(address));
  };

  return {
    bitcoinAddress,
    isValid,
    handleBitcoinAddressChange,
  };
}

export default useBitcoinAddressValidation;